import React, { lazy, Suspense, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import useGetAnime from "../hooks/useGetAnime";
import useGetCapitules from "../hooks/useGetCapitules";
import Loader, { LoaderScreen } from "../components/Loader";
// import Filter from "../components/Filter";
import Context from "../context/AppContext";

const Detail = React.lazy(() => import("../components/Detail"));
const Filter = lazy(() => import("../components/Filter"));

function Anime() {
  const { id } = useParams();
  const anime = useGetAnime(id);
  const ListOfCapitules = useGetCapitules(id);

  const { capitules, setCapitules, navigation, setNavigation, setAnime } =
    useContext(Context);

  useEffect(() => {
    if (!navigation) setNavigation(true);
    if (!ListOfCapitules)
      throw new Error("ListOfCapitules is Empty so .... fuck u");
    console.log(ListOfCapitules);
    if (!anime) throw new Error("Animeee");
    setAnime(anime);
    setCapitules(ListOfCapitules);
  }, [
    capitules,
    ListOfCapitules,
    navigation,
    setNavigation,
    anime,
    setAnime,
    setCapitules,
  ]);

  return (
    <div className="anime text-white">
      <Suspense
        fallback={
          <LoaderScreen>
            <Loader />
          </LoaderScreen>
        }
      >
        <Detail anime={anime} />
        <Filter anime={anime} capitules={capitules} />
      </Suspense>
    </div>
  );
}

export default Anime;
